import {Injectable} from "@angular/core";
import {TIntSortDirection, TIntSortListMap} from "./type";
import {Subject} from "rxjs";



@Injectable()
export class IntTableSortingService {

  sortingListMap: TIntSortListMap = new Map();
  sortingListMap$: Subject<TIntSortListMap> = new Subject<TIntSortListMap>();

  constructor() {
    this.update();
  }

  private update() {
    this.sortingListMap$.next(this.sortingListMap);
  }

  private orderFormatterPatch(list: Array<string> | string, replaceFieldsNameMap?: Map<string, string>): {[key: string]: TIntSortDirection} {
    if(typeof list === 'string') {
      const [key, value] = list.split(',');
      const obj = {} as { [key: string]: TIntSortDirection };
      const _key = (replaceFieldsNameMap && replaceFieldsNameMap.has(key)) ? replaceFieldsNameMap.get(key) : key;
      // @ts-ignore
      obj[_key] = value;
      return obj;
    } else {
      return list.reduce((acc, item) => {
        const [key, value] = item.split(',');
        const _key = (replaceFieldsNameMap && replaceFieldsNameMap.has(key)) ? replaceFieldsNameMap.get(key) : key;
        // @ts-ignore
        acc[_key] = value;
        return acc;
      }, {} as { [key: string]: TIntSortDirection })
    }
  }

  setListWithFormatting(list: Array<string> | string, replaceFieldsNameMap?: Map<string, string>) {
    this.setList(this.orderFormatterPatch(list, replaceFieldsNameMap));
  }

  setList(list: {[key: string]: TIntSortDirection}, updateAfterPatch = false) {
    Object.entries(list).forEach(([key, value]) => {
      this.sortingListMap.set(key, value);
    });
    if(updateAfterPatch) {
      this.update();
    }
  }

  set(field: string, direction: TIntSortDirection | null) {

    if(direction === null) {
      this.sortingListMap.delete(field);
    }else{
      if(this.sortingListMap.has(field)) {
        this.sortingListMap.delete(field);
      }
      this.sortingListMap.set(field, direction);
    }
    this.update();
  }

  has(fieldName: string) {
    return this.sortingListMap.has(fieldName);
  }

  getDirection(fieldName: string): TIntSortDirection | null {
    return this.sortingListMap.get(fieldName) ?? null;
  }

  formatListMapToSearch(replaceFieldsNameMap?: Map<string, string>): Array<string> {
    const mapList: Array<[string, TIntSortDirection]> = [...this.sortingListMap];
    return mapList.map(([key, value]) => {
      const _key = (replaceFieldsNameMap && replaceFieldsNameMap.has(key)) ? replaceFieldsNameMap.get(key) : key;
      return `${_key},${value}`
    });
  }
}
